import { render, staticRenderFns } from "./SalesByCategoryCustomer.vue?vue&type=template&id=38a84f78&scoped=true&"
import script from "./SalesByCategoryCustomer.vue?vue&type=script&lang=js&"
export * from "./SalesByCategoryCustomer.vue?vue&type=script&lang=js&"
import style0 from "./SalesByCategoryCustomer.vue?vue&type=style&index=0&id=38a84f78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a84f78",
  null
  
)

export default component.exports